import React, { useEffect, useState } from "react";
import { useGetPatientByUsers } from "../../../hooks/ReactQueryHooks/useGetPatientById";
import { failed } from "../../common/Toastify";
import { decryptData, encryptData } from "../../EncryptDecrypt";
import { getPatientReadingLatest } from "../api/Patient";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./patients-detail.css";
import blankProfileImage from "../../../assets/images/blank-profile-picture.webp"
import { GetVitalsUnit } from "../Threashold/Constants";
import { ViewDate, safeAgeString } from "../../../utils/DateSupport";
import { EditIndividual } from "../../Admin/Individuals/edit-individual";
import { getPatientInfo, getSingleUser } from "../../api/Individual";
import { useNavigate } from "react-router-dom";
import { Hidden, Tooltip, Box } from "@mui/material";
import { ConditionValueByOrgUnits } from "./Constants";
import { splitContactNumber } from "../../../utils/phoneNumberSupport.js";
import { getProgram } from "../../api/Program";
import EditProgram from "../../Admin/Program/EditProgram.js"
import { RelatedPerson } from "./Component/relatedPerson.js";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import moment from "moment";
import { useSelector } from "react-redux";
import EditPatientModal from "../../Admin/Individuals/EditPatientModal.js";
import { getProfilePhotoSource } from "../../../utils/signatureSupport";
import { getHCNAuthorityList } from "../../api/HCN/index.js";

const PatientCustomCard = ({from, isRPMEnable, patientName, patientId, patientEmail, orgVitalsUnit, disease, getPatientData, relatedPerson , isDependant}) => {
    const [patientsData, setPatientsData] = useState([])  // for profile card
    const [patientImage, setPatientImage] = useState("")
    const [patientDOB, setPatientDOB] = useState(null);
    const [currentProgram, setCurrentProgram] = useState([])
    const [modalShow, setModalShow] = useState(false);
    const [organizations, setOrganizations] = useState([]);
    const [organizationsData, setOrganizationsData] = useState([]);
    const [programModalShow, setProgramModalShow] = useState(false);
    const [relatedPersonModalShow, setRelatedPersonModalShow] = useState(false);
    const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
    const navigate = useNavigate();
    const [patientData, setPatientData] = useState(false);
    const handleShow = (data) => {
        setModalShow(modalShow ? false : data);
    };
    const [patientInfo, setPatientInfo] = useState(null);
    const [currentProgramDetails, setCurrentProgramDetails] = useState([])
    const handleProgramShow = (programId) => {
        modalShow ?
            setProgramModalShow(false)
            :
            getProgram(programId)
                .then((res) => setProgramModalShow(res.result))
                .catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message));
    }
    const handleRelatedPerson = () => {
        relatedPersonModalShow ? 
        setRelatedPersonModalShow(false)
        : setRelatedPersonModalShow(relatedPerson)
    }
    const [editPatientModalShow, setEditPatientModalShow] = useState(false);
    const permissions = useSelector((state) => state?.auth?.user?.permissions);
    const [hcnAuthorityDisplay, setHcnAuthorityDisplay] = useState("-");


    const handleView = () => {
        const apiBody = {
            id: patientId,
            type: "Patient",
            userOrgId: adminOrgs?.[0]?.id
        };
        getSingleUser(apiBody)
            .then((res) => {
                navigate("/app/patients-details", { state: { id: res?.data?.id, name: res?.data?.name[0]?.text, isDoctor: true } })
            })
    };

    useGetPatientByUsers({
        patientId, patientEmail, from, userOrgId: adminOrgs?.[0]?.id, onSuccess: (data) => {
            setPatientImage(getProfilePhotoSource(data?.photo));
            //setPatientDOB(decryptData(data?.birthDate)?.replace(/-/g, '/'));
            setPatientData(data);
            getPatientData(data)
            setCurrentProgram(data?.program)
        }
    })

    useEffect(() => {
        if (patientId) {
            getPatientInfo(patientId)
            .then((res) => {
                setPatientInfo(res?.result);
                setPatientDOB(decryptData(res?.result?.birthDate)?.replace(/-/g, '/'));
            })
            .catch((res) => {
                failed(res?.message || res?.result?.message)
            })
        }

    }, [patientId, editPatientModalShow])

    useOrgQuery({
        onSuccess: (data) => {
            setOrganizationsData(data);
            setOrganizations(data?.map((org) => ({ name: org?.name, value: org?.id })))
        },
        refetchOnWindowFocus: false,
    })

    // usePatientEnrolledProgramsQuery({ patientId, onSuccess: (data) => { setCurrentProgram(data.sort((a, b) => a?.program?.addedAt < b?.program?.addedAt ? -1 : 1)?.pop()?.program?.title) } })
    const reading = patientsData?.map((ele) => ele?.valueQuantity?.value)
    const temperature = reading?.find((ele) => ele?.temperature)?.temperature
    const diastolic = reading?.find((ele) => ele?.diastolic)?.diastolic
    const systolic = reading?.find((ele) => ele?.systolic)?.systolic
    const glucose = reading?.find((ele) => ele?.glucose)?.glucose
    const weight = reading?.find((ele) => ele?.weight)?.weight
    const heartRate = reading?.find((ele) => ele?.heartRate)?.heartRate
    const oxygen = reading?.find((ele) => ele?.oxygen)?.oxygen
    const rawPhone = patientInfo?.telecom?.find((ele) => ele?.system === "phone")?.value;
    const phoneNumber = splitContactNumber( typeof rawPhone === "string" ? rawPhone : "");

    const fetchProgramData = async (programId) => {
        try {
            const response = await getProgram(programId);
            setCurrentProgramDetails(response?.result?.condition);
        } catch (error) {
            failed(error?.response?.data?.message || error?.response?.data?.error || error.message);
        }
    };

    const renderSourceTag = (source) => {
        if (!source) return null;
        const sources = Array.isArray(source) ? source : [source];

        return (
            <>
                {sources.map((src, index) => (
                    <Tooltip
                        key={index}
                        title="Patient retrieved from external source"
                        arrow
                    >
                        <Box
                            component="span"
                            sx={{
                                display: "inline-block",
                                marginLeft: "8px",
                                padding: "2px 6px",
                                backgroundColor: "#e0e0e0",
                                color: "#666",
                                fontSize: "11px",
                                borderRadius: "3px",
                                fontWeight: 500,
                                cursor: "default",
                            }}
                        >
                            {src}
                        </Box>
                    </Tooltip>
                ))}
            </>
        );
    };

    useEffect(() => {
        let enc_temp = encryptData("temperature");
        let enc_wt = encryptData("weight");
        let enc_bp = encryptData("blood_pressure");
        let enc_hrate = encryptData("heart_rate");
        let enc_glucose = encryptData("blood_glucose");
        let enc_oxygen = encryptData("oxygen");

        const apiBody = {
            "patientId": patientId,
            "conditionName": JSON.stringify([enc_temp, enc_wt, enc_bp, enc_hrate, enc_glucose, enc_oxygen]),
            // "date" : moment().utc().format("MM/DD/YYYY")
        }
        // Fetch patient readings only if the currentProgram has a conditionName
        // if (currentProgram?.conditionName) {
        //     const apiBody = {
        //         "patientId": patientId,
        //         "conditionName": [encryptData(currentProgram.conditionName)]
        //     }
        // }
        getPatientReadingLatest(apiBody)
            .then((res) => {
                setPatientsData(res.data)
            })
            .catch((res) => {
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
            });

        const programCurId = currentProgram?.id; // Assuming the currentProgram has an 'id' property
        if (programCurId) {
            fetchProgramData(programCurId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentProgram])
    
    useEffect(() => {
        const fetchData = async () => {
            
            const orgId = patientInfo?.orgId || patientInfo?.managingOrganization?.[0]?.reference?.split('/')[1];
            const healthCardAuthority = getHCNAuthority(patientInfo);
            
            if (orgId && healthCardAuthority) {
                const display = await getHCNAuthorityType(orgId, healthCardAuthority);
                setHcnAuthorityDisplay(display);
            }
            else if(!healthCardAuthority) // no HCN authority exists, reset the display to "-"
                setHcnAuthorityDisplay("-") 
        };
    
        fetchData();
    }, [patientInfo]);
    
    

    const getHCNAuthority = (data) => {
        let hcnAuthority;
    
        if (data) {
            for (let i = 0; i < data?.identifier?.length; i++) {
                if (data.identifier[i].type === "HCN") {
                    hcnAuthority = data.identifier[i].system;
                    break;
                }
            }
        }
    
        return hcnAuthority;
    };

    const getHcnValue = (data) => {
        let hcnValue;
        if(data ){
            for (let i = 0; i < data?.identifier?.length; i++) {    
                if (data?.identifier[i].type === "HCN") {      
                    hcnValue = data?.identifier[i].value;
                    break;
                }
            }
        }
        return hcnValue;
    }

    const getHCNAuthorityType = async (orgId, healthCardAuthority) => {
        try {
            const res = await getHCNAuthorityList(orgId);
            const list = res?.data || [];
            const matched = list.find(item => item.authority === healthCardAuthority);
            return matched?.display || "-";
        } catch (error) {
            console.error("Error fetching HCN Authority List:", error);
            return "-";
        }
    };
    

    return (
        <div className="custom-card" style={{ padding: '10px', display:'flex' }}>
            {modalShow ?
                <EditIndividual
                    modalShow={modalShow}
                    handleShow={handleShow}
                    isReadOnly={false}
                    inactive={false}
                    typeOfUser={"Patient"}
                    refreshTable={handleView}
                    organizations={organizations}
                    organizationsData={organizationsData}
                /> : null}
            {relatedPersonModalShow ? <RelatedPerson modalShow={relatedPersonModalShow} handleShow={handleRelatedPerson}/>: null}
            {editPatientModalShow && <EditPatientModal patientId={patientInfo?.id} onShow={editPatientModalShow} onHide={() => setEditPatientModalShow(false)} hasAccessToEdit={permissions?.includes("patient-create")} organizations={organizations} patientOrgId={patientInfo?.managingOrganization?.[0]?.reference?.split("/")?.[1]} />}
            <Container style={{overflow:"hidden", alignSelf:"center"}}>                
                <Row style = {{borderBottom: '1px solid rgba(0, 0, 0, 0.14)'}}>
                    <Col style={{paddingTop:"10px"}} xs={{ span: 6, offset: 0, order:1 }} md ={{order:0}}>
                        <Tooltip  title="View Details">
                            <h1
                                className="name-header"
                                style={{ textTransform: "capitalize", cursor: 'pointer', color: "#0064a6", textDecoration: "underline" }}
                                onClick={() => {
                                    if (patientData?.type === "Patient" || patientData?.type === "RelatedPerson" ||  patientData?.type?.includes("Patient") || patientData?.resourceType === "Patient") {
                                        setEditPatientModalShow(true);
                                    } else {
                                        handleShow(patientData)
                                    }
                                }}
                            >
                                {patientInfo?.name?.[0]?.text}
                                {renderSourceTag(patientInfo?.source || patientData?.source)}
                            </h1>
                        </Tooltip>
                        <div className= "profileUpper">
                            DOB : {patientDOB ? 
                            (<><span>{ViewDate(patientDOB)}</span><span>{'   •  ' + safeAgeString(patientDOB)}</span></>) 
                            : ("-")}
                            <span style={{textTransform: "capitalize"}}>{', ' + patientInfo?.gender}</span></div>
                        {/* <div className= "profileUpper">HCN : <span>{patientData?.healthCardNumber}</span></div>  */}
                        <div className= "profileUpper " style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                            <span>Patient Identifier : {patientInfo ? getHcnValue(patientInfo) : getHcnValue(patientData)}</span>
                            <span>Identifier Type : {hcnAuthorityDisplay}</span>
                        </div> 
                    </Col>
                    <Col xxl={{ span: 2, offset: 4 }} lg={{offset:3, span:3}} md={{offset:0, span:3}}>
                        <div className="profile-new-img-wrap">
                            <img src={patientImage ? patientImage : blankProfileImage} alt="profile-pic" />
                        </div>
                    </Col>
                        
                </Row>
                <Row className ="profileText" style = {{borderBottom: '1px solid rgba(0, 0, 0, 0.14)'}}>
                    <Col md={{ span: 4, offset: 0}}>
                        <div>Address</div>
                        <div style = {{paddingBottom: '5px'}}>{patientInfo?.address?.[0]?.line?.[0]|| '-'}</div>
                        <div>Phone Number</div>
                        <div>{phoneNumber?.phone_number || '-'}</div>
                    </Col>
                    <Col>
                        <div>City</div>
                        <div>{patientInfo?.address?.[0]?.city || '-'}</div>
                        <div>Ext</div>
                        <div>{phoneNumber?.ext || '-'}</div>
                    </Col>
                    <Col md={{ span: 4, offset: 0}}>
                        <div>{patientInfo?.address?.[0]?.country === 'CA' ? "Province" : "State"}</div>
                        <div>{patientInfo?.address?.[0]?.state?.split('-')?.[1] || '-'}</div>
                        <div>Email</div>
                        <div>{patientInfo?.telecom?.find((ele) => ele?.system === "email")?.value || '-'}</div>
                    </Col>
                    <Col>
                        <div>Postal Code</div>
                        <div>{patientInfo?.address?.[0]?.postalCode || '-'}</div>
                        <div>Country</div>
                        <div>{patientInfo?.address?.[0]?.country || '-'}</div>
                    </Col>  
                        
                </Row>

                
                <Row className ="profileText" style={{alignItems:'center'}}>
                    <Col>
                        <div>Organization</div>
                        <div>{patientData?.managingOrganization?.[0]?.display || '-'}</div>
                    </Col>
                    <Col>
                        <div /* onClick={() => handleRelatedPerson()} */
                        /* style={{ textDecoration: "underline", cursor: "pointer", color: "#0064a6", fontWeight: "100" }} */>
                            { isDependant ? "Guardian(s)" : "Dependant(s)" }{/* + */}
                        </div>
                        {relatedPerson?.length > 0 ? relatedPerson?.map((relative) => {
                            return(
                                
                                <div style={{color:"#121f48", paddingBottom:"0px", wordWrap: "break-word", overflowWrap: "break-word"}}>
                                    <a href={`/app/patients-details?patientId=${relative?.id}`} style={{color: "#0064a6"}} rel="noopener noreferrer"> {relative.name}</a>
                                </div>
                            )
                            
                        }) : <div>-</div>}
                        {/* <div>Circle of Care +</div>
                        <div>{phoneNumber?.ext || '-'}</div>
                        <div>Circle of Care +</div>
                        <div>{phoneNumber?.ext || '-'}</div>
                        <div>Circle of Care +</div>
                        <div>{phoneNumber?.ext || '-'}</div> */}
                    </Col>

                </Row>
                
                
            </Container>
        </div>
    );
};

export default PatientCustomCard;
